import {
  GET_NEXT_LIKES,
  REFRESH_LIKES_PUBLISHED_AT,
  GET_LIKE_DATA_FROM_REFERENCE,
  UPDATE_LIKES_PUBLISHED_AT,
  ADD_LIKE_REF,
  UPDATE_LIKE_REF,
  DELETE_LIKE,
  SET_LIKES_PUBLICATION,
  UPDATE_LIKES_DATES,
  UPDATE_LIKES_DATA,
  RESET_LIKES_ACTION,
  MERGE_LIKE_DATA,
  MERGE_LIKE,
  RESET_LIKES
} from '../actions/favQueries'
import firebase from 'firebase'
import { _ } from 'vue-underscore'
import { postsDB } from '../../firestoreDB'
import { getUserLikesRefsPage } from '@/helper/paginate'
import { docToPostRef, docToPostData } from '@/converters/postConverter'
import {
  getIndexForNewItem,
  getIndexForItem,
  addListItem
} from '@/helper/helper'

const getDefaultState = () => ({
  likesData: [],
  likesRefs: [],
  lastFavPublishedAt: new Date().getTime() / 1000
})

const state = getDefaultState()

const getters = {
  getFavsData: state => _.compact(state.likesData),
  getFavsRefs: state => state.likesRefs,
  getLastFavPublishedAt: state => state.lastFavPublishedAt
}

const actions = {
  [GET_NEXT_LIKES]: ({ getters, dispatch, commit }) => {
    return new Promise(resolve => {
      const last = _.last(getters.getFavsRefs)
      const source = getUserLikesRefsPage((last && last.like_at))
      source.onSnapshot({ includeMetadataChanges: true }, snapshot => {
        snapshot.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let likeRef = null
          switch (docChanged.type) {
            case 'added':
              likeRef = docToPostRef(doc)
              commit(ADD_LIKE_REF, likeRef)
              dispatch(GET_LIKE_DATA_FROM_REFERENCE, likeRef)
              break
            case 'modified':
              likeRef = docToPostRef(doc)
              commit(UPDATE_LIKE_REF, likeRef)
              break
            case 'removed':
              commit(DELETE_LIKE, doc.id)
              break
            default:
              break
          }
        })
        resolve(true)
      })
    })
  },
  [GET_LIKE_DATA_FROM_REFERENCE]: ({ commit, dispatch, getters }, item) => {
    item.index =
      item.index || getIndexForItem(getters.getlikesRefs, 'docId', item.docId)
    postsDB
      .where(firebase.firestore.FieldPath.documentId(), '==', item.docId)
      .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
        snapshotDoc.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          const postData = docToPostData(doc, item)
          switch (docChanged.type) {
            case 'added':
              commit(SET_LIKES_PUBLICATION, postData)
              dispatch(UPDATE_LIKES_DATES)
              break
            case 'modified':
              commit(SET_LIKES_PUBLICATION, postData)
              dispatch(UPDATE_LIKES_DATES)
              break
            case 'removed':
              commit(DELETE_LIKE, doc.id)
              break
            default:
              break
          }
        })
      })
  },
  [UPDATE_LIKES_DATES]: ({ commit, getters }) => {
    const twoDaysInSeconds = 172800
    const minute = 60
    const todaySeconds = new Date().getTime() / 1000 // today seconds
    if (todaySeconds - getters.getLastFavPublishedAt > minute) {
      getters.getFavsData.map((item, index) => {
        if (item) {
          let seconds = item.published_at.seconds
          const diff = todaySeconds - seconds
          if (diff <= twoDaysInSeconds) {
            commit(REFRESH_LIKES_PUBLISHED_AT, { item, index })
          } else return true
        }
      })
      commit(UPDATE_LIKES_PUBLISHED_AT, todaySeconds)
    }
  },
  [RESET_LIKES_ACTION]: ({ commit }) => {
    commit(RESET_LIKES)
  },
  [MERGE_LIKE]: ({ commit }, value) => {
    commit(MERGE_LIKE_DATA, value)
  }
}

const mutations = {
  [ADD_LIKE_REF]: (state, newElement) => {
    const newIndexRef = getIndexForNewItem(
      state.likesRefs,
      'like_at',
      newElement.like_at
    )
    state.likesRefs.splice(newIndexRef, 0, newElement)
    state.likesData.splice(newIndexRef, 0, null)
  },
  [SET_LIKES_PUBLICATION]: (state, elemData) => {
    const index = getIndexForItem(state.likesRefs, 'key', elemData.key)
    if (index > -1) {
      let likesData = [...state.likesData]
      likesData[index] = elemData
      state.likesData = likesData
    }
  },
  [UPDATE_LIKE_REF]: (state, elemRef) => {
    const oldIndexRef = getIndexForItem(state.likesRefs, 'key', elemRef.key)
    const oldElemeRef = state.likesRefs[oldIndexRef]
    let elemData = null
    let newIndexRef = -1
    let hasIndexChanged = oldElemeRef.like_at !== elemRef.like_at
    if (hasIndexChanged) {
      newIndexRef = getIndexForNewItem(state.likesRefs, 'like_at', elemRef.like_at)
      hasIndexChanged = newIndexRef !== oldIndexRef
    }
    if (hasIndexChanged) {
      state.likesRefs.splice(oldIndexRef, 1)
      let elemDataList = state.likesData.splice(oldIndexRef, 1)
      elemData = elemDataList[0] || null
      newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef // Testear
      state.likesRefs = addListItem([...state.likesRefs], elemRef, newIndexRef)
      elemData = elemData ? { ...elemData, ...elemRef } : elemData
      state.likesData = addListItem([...state.likesData], elemData, newIndexRef)
    } else {
      state.likesRefs[oldIndexRef] = elemRef
      let likesData = state.likesData
      elemData = likesData[oldIndexRef]
      elemData = elemData ? { ...elemData, ...elemRef } : elemData
      likesData[oldIndexRef] = elemData
      state.likesData = [...likesData]
    }
  },
  [UPDATE_LIKES_DATA]: (state, value) => {
    state.likesData[value.index] = value
  },
  [MERGE_LIKE_DATA]: (state, value) => {
    const { key, data } = value
    let postElement = _.findWhere(state.likesData, { key: key })
    if (_.size(postElement) > 0) {
      postElement.like = data.like
      state.likesData[postElement.index] = postElement
    }
  },
  [REFRESH_LIKES_PUBLISHED_AT]: (state, { item, index }) => {
    state.likesData[index] = {
      ...state.likesData[index],
      published_at: item.published_at,
      moment: Math.random()
    }
  },
  [UPDATE_LIKES_PUBLISHED_AT]: (state, dateTimeSeconds) => {
    state.lastFavPublishedAt = dateTimeSeconds
  },
  [DELETE_LIKE]: (state, key) => {
    const postIndex = getIndexForItem(state.likesRefs, 'key', key)
    if (postIndex > -1) {
      state.likesRefs.splice(postIndex, 1)
      state.likesData.splice(postIndex, 1)
    }
  },
  [RESET_LIKES]: state => {
    Object.assign(state, getDefaultState())
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/favQuery.js